<div class="c-form-field c-form-field--password" [ngClass]="cssClass">
  <input [type]="isVisible ? 'text' : 'password'" [placeholder]="placeholder" required="required" name="password" [formControl]="control" />
  <div class="c-form-field__label">{{ label }}</div>
  <div class="c-form-field__eye" [class.-active]="isVisible" *ngIf="control.value?.length" (click)="toggleVisibility()">
    <i class="icon icon-eye"></i>
  </div>
  <div class="c-form-field__msg -error" *ngIf="errorText">{{ errorText }}</div>
</div>
